// src/layout/Dashboard/index.jsx (o donde tengas este layout)
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// auth
import { useAuth } from '@/auth/AuthContext';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const location = useLocation();
  const navigate = useNavigate();

  const { user, loading: authLoading } = useAuth();

  // solo /orders/new será full-width
  const isFullWidthPage = location.pathname === '/orders/new';

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  // 🔐 Redirigir a login si no hay usuario o no tiene role
  useEffect(() => {
    if (!authLoading) {
      const role = String(user?.role || '').trim();
      if (!role) {
        navigate('/login', { replace: true });
      }
    }
  }, [authLoading, user, navigate]);

  // Mientras carga auth o menú, mostramos loader
  if (authLoading || menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          width: 'calc(100% - 260px)',
          flexGrow: 1,
          p: isFullWidthPage ? 1 : { xs: 2, sm: 3 }
        }}
      >
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            px: isFullWidthPage ? 0 : { xs: 0, sm: 2 },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs />
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
